import { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
} from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import "@fontsource/ubuntu/300.css";
import "@fontsource/ubuntu/400.css";
import "@fontsource/ubuntu/500.css";
import "@fontsource/ubuntu/700.css";

import { LandingPage } from "pages";

const ErrorBoundary = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/");
  }, [navigate]);
  return <div>Error</div>;
};

const ErrPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/");
  }, [navigate]);
  return <div>Not Found</div>;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/",
    lazy: async () => {
      const { AdminLayout } = await import("./containers/AdminLayout");
      return { Component: AdminLayout };
    },
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "/overview",
        lazy: async () => {
          const { OverviewPage } = await import("./pages/Overview");
          return { Component: OverviewPage };
        },
      },
      {
        path: "/media_material",
        lazy: async () => {
          const { MediaMaterial } = await import("./components/MediaMaterial");
          return { Component: MediaMaterial };
        },
      },
      {
        path: "/product_license",
        lazy: async () => {
          const { LicenseListPage } = await import("./pages/LicenseList");
          return { Component: LicenseListPage };
        },
      },
      {
        path: "/file/:compType",
        lazy: async () => {
          const { ComponentListPage } = await import("./pages/ComponentList");
          return { Component: ComponentListPage };
        },
      },
    ],
  },
  {
    path: "*",
    element: <ErrPage />,
  },
]);

const primaryColor = "#1b0b38";
const secondaryColor = "#D71920";
const theme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
    error: {
      main: "#D71920",
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: `"Ubuntu", "Roboto", "Helvetica", "Arial", sans-serif`,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "28px",
          textTransform: "none",
          "&:hover": {
            boxShadow: "none",
            opacity: 0.78,
          },
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
        containedSecondary: {
          "&:hover": {
            backgroundColor: secondaryColor,
            opacity: 0.78,
          },
        },
        startIcon: {
          marginRight: 2,
        },
      },
    },
    MuiLink: {
      root: {
        color: "#241540 !important",
      },
    },
  },
});

function App() {
  return (
    <SnackbarProvider>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </SnackbarProvider>
  );
}

export default App;
